import { z } from "zod";

import type { LedgerClassificationTemplateQuery } from "@/openapi";
import { m } from "@/paraglide/messages";

function splitColumns(value: string) {
  return value
    .split(",")
    .map((column) => column.trim())
    .filter(Boolean);
}

// the grid renders the classification from the account's own classification;
// naming one of these as a source column rendered it twice

export const sourceQuerySchema = z.object({
  origin_id: z.string().min(1, m.field_is_required()),
  sql_query: z.string().trim().min(1, m.field_is_required()),
  identifiers: z
    .string()
    .refine((value) => splitColumns(value).length > 0, m.field_is_required()),
  columns: z.string(),
});
export type SourceQueryValues = z.infer<typeof sourceQuerySchema>;

export function toLedgerQuery(
  values: SourceQueryValues,
): LedgerClassificationTemplateQuery {
  return {
    classification_kind: "ledger",
    origin_id: values.origin_id,
    sql_query: values.sql_query,
    row_identifier_columns: splitColumns(values.identifiers),
    column_order: splitColumns(values.columns),
  };
}
